import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-59c43b89"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Services", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Our clients are our drivers.", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, [
  /*#__PURE__*/_createTextVNode("We're here for "),
  /*#__PURE__*/_createElementVNode("em", null, "you"),
  /*#__PURE__*/_createTextVNode(".")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "half" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Derivitec prides itself on dedicated, one-to-one support with all our clients. Whether you need new functionality, new reports, or just advice on pricing and risk management, we’re here for you. With offices in London and Hong Kong, Derivitec now provides in-hours coverage from Sydney to Los Angeles."),
    /*#__PURE__*/_createElementVNode("strong", null, "Our central philosophy is simple: the better our service to you, the better our product becomes.")
  ])
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "third" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "right" }, "Your Relationship With Derivitec")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "static divider" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Onboarding"),
    /*#__PURE__*/_createElementVNode("p", null, "From the first meeting, our aim is to show you what we can do for you in as meaningful a way as possible. We will work with you to bring representative positions into the system, and walk you through use of our applications and services in providing you with the numbers you need to see. No commitment, no lock in. ")
  ])
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns support" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "static divider" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Support"),
    /*#__PURE__*/_createElementVNode("p", null, "We focus on building long-lasting relationships with all users of our products and services. No matter how complex the task, talk to us and we’ll aim to get something working for you in days, not weeks. All clients have access to our UAT environment, allowing you to work with us quickly to ensure that what eventually goes through to production is exactly what you want.")
  ])
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "columns right" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "static divider" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "Development"),
    /*#__PURE__*/_createElementVNode("p", null, "We never stop innovating. The derivatives market is in a constant state of change and expansion, and we expand with it. New products and functionality are deployed on a weekly basis, allowing all of our clients to benefit from our ever-increasing capabilities, together.")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_panel = _resolveComponent("panel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_panel, {
      class: "head bg-right-md",
      bg: true
    }, {
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2
      ]),
      _: 1
    }),
    _createVNode(_component_panel, null, {
      default: _withCtx(() => [
        _hoisted_3,
        _hoisted_4
      ]),
      _: 1
    }),
    _createVNode(_component_panel, { class: "client-relationship" }, {
      default: _withCtx(() => [
        _hoisted_5,
        _hoisted_6,
        _hoisted_7
      ]),
      _: 1
    })
  ]))
}